import React, { useState } from 'react';

import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';

import useTextSnippets from '../hooks/useTextSnippets';
import SettingsLayout from '../SettingsLayout/SettingsLayout';
import { tableCell } from 'modules/reports/components/TableCell/TableCell';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import CreateSnippetModal from './CreateSnippetModal';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import GlobalTooltip from 'components/GlobalTooltip';
import ResizableDataTable from 'components/ResizableDataTable/ResizableDataTable';

function TextSnippets() {
  const { snippets_list, paginatorTemplate, pageSize, deleteSnippet, createSnippet, updateSnippet } = useTextSnippets({});
  const { addToast } = useToast();

  const [selectedItem, setSelectedItem] = useState(null);
  const [addNewSnippet, setAddNewSnippet] = useState(false);

  const handledeleteSnippet = (item) => {
    confirmDialog({
      message: 'Are you sure you want to delete this snippet?',
      header: 'Delete Snippet',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        deleteSnippet(item?.pk, item?.sk)
          .then((res) => {
            addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.TEXTSNIPPET_DELETE_SUCCESS);
          })
          .catch((err) => {
            addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.TEXTSNIPPET_DELETE_FAILED);
          });
      },
      reject: () => {},
    });
  };

  const actionBody = (rowData) => {
    return (
      <div>
        <span className="p-column-title text-break">Action</span>
        <span role="button" onClick={() => setSelectedItem(rowData)}>
          <GlobalTooltip tooltip={'Edit'} position="top" showDelay={500}>
            <i className="icon-edit"></i>
          </GlobalTooltip>
        </span>

        <span role="button">
          <GlobalTooltip tooltip={'Delete'} position="top" showDelay={500} className={'ms-2'}>
            <i className="icon-delete" onClick={() => handledeleteSnippet(rowData)} id="delete"></i>
          </GlobalTooltip>
        </span>
      </div>
    );
  };

  const onHide = () => {
    setSelectedItem(null);
    setAddNewSnippet(false);
  };

  const onSubmit = (formData) => {
    if (selectedItem) {
      updateSnippet(formData)
        .then((res) => {
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.TEXTSNIPPET_UPDATE_SUCCESS);
          onHide();
        })
        .catch((err) => {
          addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.TEXTSNIPPET_UPDATE_FAILED);
          console.log(err);
        });
    } else {
      createSnippet(formData)
        .then((res) => {
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.TEXTSNIPPET_CREATE_SUCCESS);
          onHide();
        })
        .catch((err) => {
          addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.TEXTSNIPPET_CREATE_FAILED);
          console.log(err);
        });
    }
  };

  return (
    <>
      <GlobalLoader />
      <div className="container-fluid px-0">
        <GlobalLoader />
        <div className="row">
          <div className="col-12 d-flex justify-content-between mb-3">
            <h1 className="title gray-800 mb-0 fs-3 fs-md-1">Text Snippets</h1>
            <Button
              label="Add Snippet"
              icon="pi pi-plus"
              className="p-button-raised p-button-rounded p-button-primary"
              onClick={() => setAddNewSnippet(true)}
            />
          </div>
        </div>
        <div className="col-12 team-table datatable-responsive">
          <ResizableDataTable
            value={snippets_list}
            responsiveLayout="scroll"
            className="card-bg p-datatable-responsive"
            emptyMessage="No Data Found."
            paginatorTemplate={paginatorTemplate}
            rows={pageSize}
            sortField=""
            stripedRows
            paginator
            resizableColumns
            storageKey="text_snippets_column_widths"
            columns={[
              { field: 'text_snippet_keyword', header: 'Snippet', body: tableCell, bodyClassName: 'ellipsis-text', sortable: true },
              { field: 'text_snippet_expansion', header: 'Expand Text', body: tableCell, bodyClassName: 'ellipsis-text', sortable: true },
              { field: 'action', header: 'Action', body: actionBody, fixed: true, width: '120px', resizable: false },
            ]}
          />
        </div>
        {(Boolean(selectedItem) || addNewSnippet) && <CreateSnippetModal selectedItem={selectedItem} onHide={onHide} onSubmit={onSubmit} />}
      </div>
    </>
  );
}

export const TextSnippetsWrapper = () => {
  return (
    <SettingsLayout>
      <TextSnippets />
    </SettingsLayout>
  );
};
